import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';
import axios from 'axios';
const user = getLoggedUser();

async function createOrganization(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'organizations', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function getClients() {
  return fetch(apiUrl + 'clients', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((data) => data.json());
}

async function getClientsNew() {
  return fetch(`${apiUrl}v2/clients`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((data) => data.json());
}
async function getClientsAuctions(params) {
  return fetch(`${apiUrl}v2/clients-auctions?${params}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((data) => data.json())
    .catch((err) => {
      console.error('getClientsNew error:', err);
      return null;
    });
}

async function getOrganizations(q) {
  return fetch(apiUrl + 'active_organizations?' + q, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((data) => data.json());
}

async function getOrganizationList(q) {
  let endpoint = apiUrl + 'organizations/list?';
  if (q) {
    endpoint += q;
  }
  return fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}
async function getAllOrganization(q) {
  let endpoint = apiUrl + 'organizations?';
  if (q) {
    endpoint += q;
  }
  return fetch(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getOganization(id) {
  return fetch(apiUrl + 'organizations/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function updateOrganization(payload, id) {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'organizations/' + id, payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

function deleteOrganization(id) {
  return fetch(apiUrl + 'organizations/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'applications/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export {
  createOrganization,
  getAllOrganization,
  getOrganizations,
  getOganization,
  updateOrganization,
  deleteOrganization,
  getClients,
  getOrganizationList,
  getClientsNew,
  getClientsAuctions
};
